/**
 * Utilitários de telefone brasileiro compartilhados
 * (onboarding, settings, formulários de captura).
 */

/** Aplica a máscara (11) 99999-9999 / (11) 9999-9999 conforme o usuário digita. */
export function formatPhoneBR(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
  }
  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
}

/**
 * Valida um número de WhatsApp brasileiro (valor mascarado ou só dígitos).
 *
 * Aceita 10 ou 11 dígitos — decisão de produto: inclui WhatsApp Business
 * em número fixo e mantém consistência com a validação do Settings.
 */
export function isValidWhatsAppBR(value: string): boolean {
  const digits = value.replace(/\D/g, '')
  return digits.length === 10 || digits.length === 11
}
